module.exports = __webpack_public_path__ + "img/feedback2-1.e68fc211.jpg";